import { formatDateTime } from '@/lib/utils/formatDateTime'

/**
 * Compact relative time ("22m ago", "3d ago") for recent timestamps,
 * falling back to the absolute `formatDateTime` past a week (where
 * relative loses precision). Used by list "last sign-in" cells and the
 * user-detail drawer's activity feed — mirrors the reference's relative
 * timestamps. `null`/invalid → em-dash.
 */
export function timeAgo(iso: string | null | undefined): string {
  if (!iso) return '—'
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return '—'
  const s = Math.max(0, Math.round((Date.now() - then) / 1000))
  if (s < 60) return `${s}s ago`
  const m = Math.round(s / 60)
  if (m < 60) return `${m}m ago`
  const h = Math.round(m / 60)
  if (h < 24) return `${h}h ago`
  const d = Math.round(h / 24)
  if (d < 7) return `${d}d ago`
  return formatDateTime(iso)
}
